import { CreateSOPPayload } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useCreateSOP(
  onSuccess?: () => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/sop/create`;

  const request = new Request(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<null, CreateSOPPayload>(request, {
    onSuccessInvalidationKeys: [['sop'], ['sop-alarm-types']],
    onSuccess,
    onError,
  });
}

export default useCreateSOP;
